<template>
  <div class="ArticleDetail text-left" v-title data-title="详情">
    <ArticleDetailCom :fetchDetailApi="getArticleDetail" :detailId="$route.params.id"/>
  </div>
</template>

<script>
import { getArticleDetail } from '@/network/NetworkAccessor';
import storage from '@/uitls/cacheUtil';
import ArticleDetailCom from './components/ArticleDetailCom.vue';

export default {
  name: 'ArticleDetail',
  components: { ArticleDetailCom },
  data() {
    return {
      getArticleDetail,
      title: '文章预览',
      loading: false,
      detail: {
        id: '',
        title: '',
        author: '',
        content: '',
        cover: '',
        abstracts: '',
        type: '',
      },
    };
  },
  computed: {
  },
  methods: {
    back() {
      this.$router.back();
      // this.$router.push('/home');
    },
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
    storage.local.remove('article_info');
  },
};
</script>

<style scoped>
  .ArticleDetail {
  }
</style>
